import { CosmicJSClient } from "../../apis/cosmicjs-client";
import { CosmicJSError, HelpContent } from "../../domain/help/help-entity";

const CONTENTS_OBJECT_TYPE = "help-articles" as const;

const BUCKET = `graffer-console-contents` as const;

class ContentService extends CosmicJSClient {
  constructor() {
    super(BUCKET);
  }

  private replaceURL(content: string) {
    // NOTE(adshidtadka): PATHに`/files`を含めることでLGWAN環境内でgo-file-proxyにプロキシされる
    // さらに、PATHに`/files/cdn`を含めることでgo-file-proxyにおいてブラウザにレンダリングするためのコンテンツであると判断して画像を無害化をしない
    // https://github.com/graffer-inc/go-file-proxy/blob/master/main.go#L49-L55
    const proxyUrl = location.origin + "/files/cdn/cosmicjs";
    return content.replace(/https?:\/\/cdn.cosmicjs.com/g, proxyUrl);
  }

  async fetchContent(slug: string): Promise<HelpContent | null> {
    const result = await this.fetch<HelpContent>(
      JSON.stringify({
        type: CONTENTS_OBJECT_TYPE,
        slug: slug,
      }),
      "id," +
        "slug," +
        "title," +
        "metadata.content," +
        "metadata.product," +
        "metadata.tag," +
        "metadata.parent.slug," +
        "metadata.parent.title," +
        "metadata.parent.metadata.parent.slug," +
        "metadata.parent.metadata.parent.title," +
        "metadata.parent.metadata.parent.metadata.parent.slug," +
        "metadata.parent.metadata.parent.metadata.parent.title," +
        "metadata.parent.metadata.parent.metadata.parent.metadata.parent.slug," +
        "metadata.parent.metadata.parent.metadata.parent.metadata.parent.title,",
      "-order",
    );

    /**
     * contentが見つからない場合はコンテンツ詳細ページが表示できないのでエラーをthrowし、error boundaryでエラーページを表示する
     */
    if (result?.objects && result.objects.length === 0) {
      throw new CosmicJSError({
        error: new Error("Content not found"),
        code: "404",
      });
    }
    return {
      ...result.objects[0],
      metadata: {
        ...result.objects[0].metadata,
        content: this.replaceURL(result.objects[0].metadata.content),
      },
    };
  }
}

export const contentService = new ContentService();
